import {
  DalsiPredkladatelUuid as DalsiPredkladatelUuidGenerated,
  LegislativnyMaterialUpdateApi,
  LegMaterialUpdate,
} from 'elegislativa-frontend-ts-axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import LegislativnyMaterialCreateUpdate
  from '../../model/legislativnyMaterial/LegislativnyMaterialCreateUpdate';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';
import Predkladatel from '../../model/legislativnyMaterial/Predkladatel';

const client = new LegislativnyMaterialUpdateApi(apiConfiguration(elegislativaPrefixPath));

const map = (legMaterial: LegislativnyMaterialCreateUpdate): LegMaterialUpdate => ({
  oblastListUuid: legMaterial.oblastList.map(oblast => oblast.uuid),
  nazov: legMaterial.nazov,
  rezortneCislo: legMaterial.rezortneCislo,
  podnet: legMaterial.podnet,
  suvisiaceProcesy: legMaterial?.suvisiaceProcesy?.map(proces => proces.cisloLp),
  zodpovednaInstituciaUuid: legMaterial?.zodpovednaInstitucia?.uuid,
  zodpovednaInstituciaLdapUuid: legMaterial?.zodpovednaInstitucia?.ldapUuid,
  zodpovednyPredkladatelUuid: legMaterial.zodpovednyPredkladatel ? legMaterial.zodpovednyPredkladatel.uuid : null,
  dalsiPredkladatelia: legMaterial.dalsiPredkladatelia
    .filter(dalsiPredkladatel => dalsiPredkladatel?.predkladatel)
    .map(predkladatel => mapDalsiPredkladatelUuid(predkladatel)),
});

const mapDalsiPredkladatelUuid = (dalsiPredkladatel: Predkladatel): DalsiPredkladatelUuidGenerated => ({
  predkladatelUuid: dalsiPredkladatel.predkladatel.uuid,
  organizaciaUuid: dalsiPredkladatel.organizacia.uuid,
});

// eslint-disable-next-line import/prefer-default-export
export const updateLegMaterial = async (
  type: string,
  year: number,
  index: number,
  legMaterial: LegislativnyMaterialCreateUpdate,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const { status } = await client.updateLegMaterial(type, year, index, map(legMaterial), headers);
  return {
    responseCode: status,
  };
};
